export default class Untersuchung {
    public untersuchung_id: number | null = null;
    public code: string | null = null;
    public untersuchung: string | null = null;
    public untersuchungsbefundvariante: number | null = null;
    public untersuchungsbefundvariante_bezeichnung: string | null = null;
    public einheit: string | null = null;
    public preis: number | null = null;
    public verrechnung: string | null = 'n';
    public sort: number | null = 0;
    public steuersatz: number | null = null;
    public konto: string | null = null;
    public gueltig: string | null = 'j';
    /** j/n */
    public kassenleistung: string | null = 'n';
    /** 0=keine HCW-Untersuchung,1=immer HCW-Untersuchung, 2=mögliche HCW-Untersuchung */
    public hcw: any | null = null;
    /** Preis der Untersuchung in EURO (brutto) */
    public preis_mitarbeiter: number | null = null;
    /** Preis der Untersuchung in EURO (brutto) */
    public preis_rektorat: number | null = null;
    public select_by_default: string | null = 'n';

    constructor(data?: Partial<Untersuchung>) {
        Object.assign(this, data);
    }
}
